module.exports = __webpack_public_path__ + "img/jiaxiangyouxi.fc50eeb4.png";